import { z } from 'zod';
import { defineEndpoint } from '../define';
import { GithubSyncStatusSchema } from './shapes';

export const RunnerOverviewSchema = z.object({
  machines: z.object({ online: z.number().int(), offline: z.number().int() }),
  runners: z.object({ busy: z.number().int(), idle: z.number().int(), offline: z.number().int() }),
  jobs: z.object({ running: z.number().int(), queued: z.number().int() }),
  /** Wait so far of the oldest job still queued for a runner; null when none. */
  longestQueuedSeconds: z.number().int().nullable(),
  github: GithubSyncStatusSchema,
});
export type RunnerOverview = z.infer<typeof RunnerOverviewSchema>;

export const getRunnerOverview = defineEndpoint({
  method: 'GET',
  path: '/v1/runner-monitor/overview',
  params: z.object({}),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: RunnerOverviewSchema }),
});
